// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FmcSW","colBig":"styles_colBig__3spaM","colSmall":"styles_colSmall__3IpTy"};